
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import {
    IonButtons,
    IonBackButton,
    IonAccordionGroup,
    IonAccordion,
    IonModal,
    IonGrid,
    IonFooter,
    IonRow,
    IonCol,
    IonContent,
    IonHeader, IonPage, IonTitle, IonToolbar,
    IonApp,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    setupIonicReact,
    IonButton,
    IonRouterContext,
    IonRouteProps,
    IonLoading,
    IonToast,
    IonCard,
    IonFabButton,
    IonInfiniteScroll,
    IonSegment,
    IonSegmentButton,
    IonList,
    IonItem,
    IonText,
    IonFab,
    IonSearchbar,
    IonTextarea,
    IonInfiniteScrollContent,
    IonCheckbox,
    withIonLifeCycle, IonRefresher, IonRefresherContent
} from '@ionic/react';

import { arrowUp, business, barcode, person, podium, closeOutline, search, add, ticketOutline, receiptOutline, personOutline, callOutline, logoWhatsapp, locationOutline, mapOutline } from 'ionicons/icons';
import { DebounceInput } from 'react-debounce-input';
import Moment from 'react-moment';
import moment from 'moment';
import { Capacitor } from '@capacitor/core';

import { getContact, getPermissions, getShoppingCart, getTransactions, getLoginApp, getTransactionPayments } from '../../utils/functions';
import PosActions from '../../actions/PosActions';

const options2 = { style: 'currency', currency: 'USD', useGrouping: false };
const _numberFormat = new Intl.NumberFormat('en-US', options2);
import Select from 'react-select';
import { Printer } from '@bcyesil/capacitor-plugin-printer';

import ContactList from './ContactList';
import PaymentsList from './PaymentsList';

interface IProps {
    get_: any;
    setData_: any;
    post_: any;
}

interface IState {
    segmentActive: any;
    loading: any;
}

class Contacts extends React.Component<IProps, IState> {
    contentRef: React.RefObject<HTMLIonContentElement>;
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;
    ContactList: any;
    PaymentsList: any;
    constructor(props: any) {
        super(props)
        this.contentRef = React.createRef<HTMLIonContentElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();
        this.ContactList = React.createRef();
        this.PaymentsList = React.createRef();

        this.state = {
            segmentActive: props.segmentActive,
            loading: props.loading,

        }
    }

    async componentDidMount() {
        this.props.setData_({ data_pagin: [] });

        let data_login_ari_app: any = !getLoginApp() ? [] : getLoginApp();

        this.props.get_({
            typeOption: 'get_data_default',
            user_id: data_login_ari_app.id,
        }, "api/get_data_default");

        this.setState({
            segmentActive: 1,
            loading: false,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            loading: nextProps.data.loading && nextProps.data.loading.isOpen ? nextProps.data.loading.isOpen : false,
        });
    }

    render() {
        const { segmentActive, loading } = this.state;

        return (
            <IonPage>
                <div id="print-area" className="print-area" style={{ display: 'none', width: 0, height: 0, border: 'none' }} title="Print Area"></div>

                <IonLoading
                    //color="light"
                    cssClass='my-custom-class no-print'
                    isOpen={loading}
                    message={'Cargando...'}
                />
                <IonHeader className='no-print'>
                    <IonToolbar color="primary">
                        <IonButtons slot="start">
                            <IonBackButton defaultHref="/home" text={""} />
                        </IonButtons>
                        <IonTitle>Cuenta X Cobrar</IonTitle>
                    </IonToolbar>

                </IonHeader>
                <IonContent fullscreen scrollEvents={true} className='no-print'>
                    <IonRow>
                        <IonCol col-12 size='12' class='div_horizontal_buttom_segment_pos_home'>
                            <IonSegment value={segmentActive}>
                                <IonSegmentButton
                                    value={1}
                                    onClick={() => {
                                        this.setState({
                                            segmentActive: 1
                                        });
                                    }}
                                >
                                    <IonLabel>Clientes</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton
                                    value={2}
                                    onClick={() => {
                                        this.setState({
                                            segmentActive: 2
                                        });
                                    }}
                                >
                                    <IonLabel>Abonos</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                        </IonCol>
                        {
                            segmentActive == 1 ?
                                <>
                                    <IonCol col-12 size='12'>
                                        <ContactList ref={this.ContactList} />
                                    </IonCol>
                                </>
                                : null
                        }
                        {
                            segmentActive == 2 ?
                                <>
                                    <IonCol col-12 size='12'>
                                        <PaymentsList ref={this.PaymentsList} />
                                    </IonCol>
                                </>
                                : null
                        }
                    </IonRow>
                </IonContent>
            </IonPage>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
        setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),
        post_: (fields: any, controller: string) => dispatch(PosActions.post_(fields, controller))
    }
};

export default withIonLifeCycle(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Contacts));

